export const PersonaBadge = ({ persona, label, testId }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${persona === "PM" ? "bg-[#eef4ff] text-[#0a47be]" : "bg-[#f1f4f9] text-[#3b475c]"}`}
    data-testid={testId}
  >
    {label}
  </span>
);
